import React, { useState } from 'react'
import * as UIcons from '@iconscout/react-unicons'

const IP_PATTERN = /^(\d{1,3}\.){3}\d{1,3}(\/\d{1,2})?$/

export default function IpRangeInput({ label, placeholder, values = [], onChange }) {
  const [draft, setDraft] = useState('')
  const [error, setError] = useState('')

  const addValue = () => {
    const trimmed = draft.trim()
    if (!trimmed) return

    if (!IP_PATTERN.test(trimmed)) {
      setError('Enter a valid IP or CIDR range')
      return
    }

    if (!values.includes(trimmed)) onChange([...values, trimmed])
    setDraft('')
    setError('')
  }

  const removeValue = (value) => onChange(values.filter((entry) => entry !== value))

  return (
    <div className="flex flex-col gap-2">
      {label && <label className="text-sm font-medium text-dark-blue">{label}</label>}

      <input
        type="text"
        value={draft}
        onChange={(event) => { setDraft(event.target.value); setError('') }}
        onKeyDown={(event) => { if (event.key === 'Enter') { event.preventDefault(); addValue() } }}
        placeholder={placeholder}
        className="w-full border border-border-lines rounded-lg px-3 py-2.5 text-sm text-dark-blue outline-none"
      />

      {error && <p className="text-xs text-danger">{error}</p>}

      {
        values.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {
              values.map((value) => (
                <span key={value} className="inline-flex items-center gap-1.5 bg-background rounded-full pl-3 pr-2 py-1 text-xs font-medium text-dark-blue">
                  {value}
                  <button type="button" onClick={() => removeValue(value)} className="flex items-center justify-center">
                    <UIcons.UilTimes size={12} className="text-secondary" />
                  </button>
                </span>
              ))
            }
          </div>
        )
      }
    </div>
  )
}
